import React, { useEffect } from 'react';
import doLog from '@/common/log';
import './index.less';

//榜单相关
export default function Billboard({
  recommendBillboard,
}: {
  recommendBillboard: TitleType.RecommendBillboard;
}) {
  useEffect(() => {
    doLog('/sc.details.popular', '', 'EXP');
  }, []);
  if (!recommendBillboard) {
    return null;
  }
  const { action, rankText, descText = '', cateText } = recommendBillboard;
  //descText: "Most popular in {1}"
  const rankInfoText = descText.replace('{1}', '');
  return (
    <span className="detail-honorary-title detail-separator">
      {rankText}
      <a
        className="popular-action"
        href={action}
        target="_blank"
        onClick={() => {
          doLog('/sc.details.popular');
        }}
      >
        {`${rankInfoText} ${cateText}`}
      </a>
    </span>
  );
}
